(() => {
  'use strict';
  const id = value => String(value || '').split('/').pop();
  const list = value => Array.isArray(value) ? value : [];
  function offer(product, snapshot, time, currency) {
    const synced = Number(snapshot?.syncedAt) * 1000;
    if (snapshot?.version !== 1 || snapshot.complete !== true || !Number.isFinite(synced) || synced > time + 60000 || time - synced > 1800000 || currency !== 'USD' || product.available !== true || product.giftCard || !Array.isArray(product.variants) || product.variantCount !== product.variants.length) return null;
    const campaigns = (Array.isArray(snapshot.campaigns) ? snapshot.campaigns : []).filter(c => c && c.combinesProduct === false && c.named === true && c.context === 'DiscountBuyerSelectionAll' && !c.minimum && c.productClass === true && c.oneTime === true && ['ACTIVE', 'SCHEDULED'].includes(c.status) && Date.parse(c.starts) <= time && time < Date.parse(c.ends) && Date.parse(c.ends) > Date.parse(c.starts));
    const variants = product.variants.filter(v => v && v.available && Number.isSafeInteger(v.price) && v.price > 0).map(v => {
      let price = v.price, campaign = null;
      for (const c of campaigns) {
        const matches = c.all === true || (list(c.products).some(x => id(x) === id(product.id)) && !list(c.variantProducts).some(x => id(x) === id(product.id))) || list(c.variants).some(x => id(x) === id(v.id)) || list(c.collections).some(x => list(product.collections).some(y => id(x) === id(y)));
        if (!matches) continue;
        let next = v.price;
        if (c.kind === 'DiscountPercentage' && Number(c.percent) > 0 && Number(c.percent) <= 1) next = v.price - Math.round(v.price * Number(c.percent));
        if (c.kind === 'DiscountAmount' && c.each === true && c.currency === currency && Number.isFinite(Number(c.amount)) && Number(c.amount) > 0) next = Math.max(0, v.price - Math.round(Number(c.amount) * 100));
        if (next < price || (next === price && campaign && String(c.id) < String(campaign.id))) { price = next; campaign = c; }
      }
      return { ...v, salePrice: price, campaign };
    });
    if (!variants.length) return null;
    const pack = variants.every(v => Number.isSafeInteger(v.quantity) && v.quantity > 1 && v.unit && v.unit === variants[0].unit);
    variants.sort((a, b) => (pack ? a.salePrice / a.quantity - b.salePrice / b.quantity : a.salePrice - b.salePrice) || (String(a.id) < String(b.id) ? -1 : 1));
    const chosen = variants[0];
    if (!chosen.campaign || chosen.salePrice >= chosen.price) return null;
    return { ...chosen, pack, from: variants.some(v => pack ? v.salePrice / v.quantity !== chosen.salePrice / chosen.quantity || v.quantity !== chosen.quantity : v.salePrice !== chosen.salePrice), starts: chosen.campaign.starts, ends: chosen.campaign.ends };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { offer };
  if (typeof window === 'undefined') return;
  let snapshot = null;
  const source = document.querySelector('[data-lisa-sale-snapshot]');
  try { snapshot = JSON.parse(source?.textContent || 'null'); } catch (_) {}
  window.LisaSales = { offer: (p, time) => offer(p, snapshot, time, source?.dataset.currency), set: data => { snapshot = data; } };
  async function refresh() {
    if (document.hidden) return;
    try {
      const url = new URL(location.href); url.searchParams.delete('sections'); url.searchParams.set('section_id', 'lisa-sale-data');
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const node = doc.querySelector('[data-lisa-sale-snapshot]');
      if (node) snapshot = JSON.parse(node.textContent);
    } catch (_) {}
  }
  setInterval(refresh, 60000);
  document.addEventListener('visibilitychange', refresh);
})();
